import { Component, Inject } from '@angular/core';
import { InstructionsSteps } from '../instructions-step/instructions-step.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'common-instructions-dialog',
  templateUrl: './instructions-dialog.component.html',
  styleUrls: ['./instructions-dialog.component.scss'],
})
export class InstructionsDialogComponent {
  protected readonly InstructionsSteps = InstructionsSteps;
  brandColor = '';
  textColor = '';
  labelUrl?: string;

  constructor(
    public dialogRef: MatDialogRef<InstructionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { brandColor: string; textColor: string; labelUrl?: string; deliveryPartner?: string },
  ) {
    this.brandColor = data.brandColor;
    this.textColor = data.textColor;
    this.labelUrl = data.labelUrl;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
